import { render } from "./navelementLink.vue?vue&type=template&id=4eb0863c&scoped=true"
import script from "./navelementLink.vue?vue&type=script&lang=js"
export * from "./navelementLink.vue?vue&type=script&lang=js"

import "./navelementLink.vue?vue&type=style&index=0&id=4eb0863c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb0863c"]])

export default __exports__